import { Text as RNText, TextProps as RNTextProps } from "react-native";

import { TextColor, colors, createBox, createStyles } from "../theme";
import { MarginProps } from "./box";

type TextBaseProps = RNTextProps & {
  color?: TextColor;
  center?: boolean;
  disabled?: boolean;
  em?: boolean;
};

const TextBase = ({
  center = false,
  color: colorName,
  disabled = false,
  em = false,
  style,
  ...rest
}: TextBaseProps) => {
  const color = colorName ? colors[colorName] : null;

  return (
    <RNText
      {...rest}
      style={[
        $.default,
        center && $.center,
        em && $.emphasize,
        style,
        !!color && { color },
      ]}
    />
  );
};

const TextBaseBox = createBox<TextBaseProps>(TextBase);

export const TextParagraph = TextBaseBox;

type TextPublicProps = TextBaseProps &
  MarginProps & {
    small?: boolean;
  };

export const TextBody = ({
  small = false,
  style,
  ...rest
}: TextPublicProps) => {
  return (
    <TextBaseBox {...rest} style={[$.body, small && $.bodySmall, style]} />
  );
};

export const TextLabel = ({
  small = false,
  style,
  ...rest
}: TextPublicProps) => {
  return (
    <TextBaseBox {...rest} style={[$.label, small && $.labelSmall, style]} />
  );
};

export const TextTitle = ({
  small = false,
  style,
  ...rest
}: TextPublicProps) => {
  return <TextBaseBox {...rest} em style={[$.title, style]} />;
};

export const TextLink = ({ style, ...rest }: TextPublicProps) => {
  return <TextBaseBox {...rest} style={[$.link, style]} />;
};

const $ = createStyles({
  default: {
    fontFamily: "BrandRegular",
  },
  center: {
    textAlign: "center",
  },
  emphasize: {
    fontFamily: "BrandMedium",
  },
  body: {
    color: "onSurface",
    fontSize: 16,
    lineHeight: 24,
  },
  bodySmall: {
    fontSize: 14,
    lineHeight: 20,
  },
  title: {
    color: "onSurface",
    fontSize: 18,
    lineHeight: 28,
  },
  label: {
    color: "onSurfaceDim",
    fontSize: 12,
    lineHeight: 16,
  },
  labelSmall: {
    fontSize: 10,
    lineHeight: 14,
  },
  link: {
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    textDecorationColor: "white",
  },
});
